export default __webpack_public_path__ + "static/media/mid-b-13.6cb4e384.jpg";